import { useMemo } from "react";

import { MapFilterEntityType } from "@mapmycustomers/shared/types/entity";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import { ModifiedMapFilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";
import { isDefined } from "@mapmycustomers/shared/util/assert";

import getFilteredFields from "@app/component/filtering/utils/getFilteredFields";
import getFieldModelByEntityType from "@app/util/fieldModel/getByEntityType";

import { FILTER_ENTITY_TYPES } from "./consts";

const useFilteredFields = (
  filters: ModifiedMapFilterModel,
  hiddenFields?: IField[]
): Partial<Record<MapFilterEntityType, IField[]>> =>
  useMemo(
    () =>
      FILTER_ENTITY_TYPES.reduce((result, entityType) => {
        const fieldModel = getFieldModelByEntityType(entityType);
        return {
          ...result,
          [entityType]: isDefined(filters[entityType])
            ? getFilteredFields(fieldModel, filters[entityType]!, hiddenFields)
            : undefined,
        };
      }, {}),
    [filters, hiddenFields]
  );

export default useFilteredFields;
